module.exports = __webpack_public_path__ + "img/304.png";